import { FC } from 'react';
import { Money } from 'types';
import { CreditVoucherDisclaimer } from 'components/Disclaimers';
import VoucherExpireLineItem from './components/VoucherExpiryLineItem';
import PaymentsCard from 'components/PaymentsCard';
import LineItem from 'components/LineItem';
import BottomTotal from 'components/BottomTotal';
import { CardProps } from '@qga/roo-ui/components';

interface CreditVoucherRefundBreakdownProps extends CardProps {
  voucherTotal: Money;
}

const creditVoucherTitle = (
  <>
    Credit voucher
    <CreditVoucherDisclaimer.Link />
  </>
);

const CreditVoucherRefundBreakdown: FC<CreditVoucherRefundBreakdownProps> = ({ voucherTotal, ...styles }) => (
  <PaymentsCard {...styles}>
    <LineItem title={creditVoucherTitle} totals={[voucherTotal]} />
    <VoucherExpireLineItem />
    <BottomTotal title="Total refund" totals={[voucherTotal]} />
  </PaymentsCard>
);

export default CreditVoucherRefundBreakdown;
